<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button (click)="goBack()"></glxy-page-nav-button>
    </glxy-page-nav>
    @if (assistant$ | async; as assistant) {
      <glxy-page-title>
        {{ assistant | assistantName }} -
        @if (isVoice) {
          {{ 'AI_ASSISTANT.TESTING.GENERATE.TITLE_VOICE' | translate }}
        } @else {
          {{ 'AI_ASSISTANT.TESTING.GENERATE.TITLE_CHAT' | translate }}
        }
      </glxy-page-title>
    }
  </glxy-page-toolbar>

  <glxy-page-wrapper widthPreset="default">
    <div class="row row-gutters">
      <div class="col col-xs-12">
        <mat-card>
          <mat-card-header>
            <mat-card-title>
              @if (isVoice) {
                {{ 'AI_ASSISTANT.TESTING.GENERATE.TITLE_VOICE' | translate }}
              } @else {
                {{ 'AI_ASSISTANT.TESTING.GENERATE.TITLE_CHAT' | translate }}
              }
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <glxy-form-field>
              <glxy-label>{{ 'AI_ASSISTANT.TESTING.GENERATE.INSTRUCTIONS_LABEL' | translate }}</glxy-label>
              <textarea
                matInput
                [formControl]="instructionsControl"
                [placeholder]="'AI_ASSISTANT.TESTING.GENERATE.INSTRUCTIONS_PLACEHOLDER' | translate"
                rows="4"
              ></textarea>
              <glxy-hint>{{ 'AI_ASSISTANT.TESTING.GENERATE.INSTRUCTIONS_HINT' | translate }}</glxy-hint>
            </glxy-form-field>
            <glxy-button-group>
              <button mat-raised-button color="primary" (click)="generate()" [disabled]="generating">
                <glxy-button-loading-indicator [isLoading]="generating">{{
                  'AI_ASSISTANT.TESTING.GENERATE.GENERATE' | translate
                }}</glxy-button-loading-indicator>
              </button>
            </glxy-button-group>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    @if (hasGenerated && generatedCases.length === 0) {
      <div class="row row-gutters">
        <div class="col col-xs-12">
          <glxy-empty-state size="small">
            <glxy-empty-state-hero>
              <mat-icon>science</mat-icon>
            </glxy-empty-state-hero>
            <glxy-empty-state-title>{{ 'AI_ASSISTANT.TESTING.GENERATE.NO_CASES' | translate }}</glxy-empty-state-title>
            <glxy-empty-state-footnote>{{
              'AI_ASSISTANT.TESTING.GENERATE.NO_CASES_HINT' | translate
            }}</glxy-empty-state-footnote>
            <glxy-empty-state-actions>
              <button mat-raised-button color="primary" (click)="generate()">
                {{ 'AI_ASSISTANT.TESTING.GENERATE.TRY_AGAIN' | translate }}
              </button>
            </glxy-empty-state-actions>
          </glxy-empty-state>
        </div>
      </div>
    } @else if (generatedCases.length > 0) {
      <div class="row row-gutters">
        <div class="col col-xs-12">
          <mat-card>
            <mat-card-header>
              <mat-card-title
                >{{ 'AI_ASSISTANT.TESTING.GENERATE.GENERATED_CASES' | translate }} ({{
                  generatedCases.length
                }})</mat-card-title
              >
            </mat-card-header>
            <mat-card-content>
              <table mat-table [dataSource]="generatedCases">
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>{{ 'AI_ASSISTANT.TESTING.TEST_CASES.NAME' | translate }}</th>
                  <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>

                <ng-container matColumnDef="prompt">
                  <th mat-header-cell *matHeaderCellDef>{{ 'AI_ASSISTANT.TESTING.TEST_CASES.PROMPT' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    @if (isVoice) {
                      {{ element.callerInstructions }}
                    } @else if (element.chatHistory?.length === 1) {
                      {{ element.chatHistory[0].content }}
                    } @else if (element.chatHistory?.length > 1) {
                      {{ element.chatHistory.length }} {{ 'AI_ASSISTANT.TESTING.GENERATE.MESSAGES' | translate }}
                    }
                  </td>
                </ng-container>

                <ng-container matColumnDef="expectation">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ 'AI_ASSISTANT.TESTING.TEST_CASES.EXPECTATION' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.expectation }}</td>
                </ng-container>

                <ng-container matColumnDef="edit">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <button (click)="editCase(i)" mat-icon-button>
                      <mat-icon>edit</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <ng-container matColumnDef="remove">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <button (click)="removeCase(i)" mat-icon-button>
                      <mat-icon>close</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </mat-card-content>
            <mat-card-actions>
              <glxy-button-group>
                <button mat-raised-button color="primary" (click)="saveAll()" [disabled]="saving">
                  <glxy-button-loading-indicator [isLoading]="saving">{{
                    'AI_ASSISTANT.TESTING.GENERATE.SAVE_ALL' | translate
                  }}</glxy-button-loading-indicator>
                </button>
              </glxy-button-group>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
    }
  </glxy-page-wrapper>
</glxy-page>
